import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { TranslateModule } from '@ngx-translate/core'
import { SeRegistrationUiFeatureOpenRegistrationListModule } from '@se-po/se-registration-ui-feature-open-registration-list'
import { SeRegistrationUiRegistrationCardModule } from '@se-po/se-registration-ui-registration-card'
import { SeFeButtonModule } from 'se-fe-button'
import { SeFeEmptyStateModule } from 'se-fe-empty-state'
import { SeFeIconModule, seFeIconSpotFlatBall, seFeIconSpotServiceBreakdown } from 'se-fe-icon'
import { SeFePageModule } from 'se-fe-page'
import { SeFeSpinnerModule } from 'se-fe-spinner'
import { SeFeTranslationsModule } from 'se-fe-translations'
import { CompletedRegistrationListComponent } from './completed-registration-list/completed-registration-list.component'

@NgModule({
  imports: [
    CommonModule,
    SeFeButtonModule,
    SeFeEmptyStateModule,
    SeFeIconModule.include([
      seFeIconSpotFlatBall,
      seFeIconSpotServiceBreakdown,
    ]),
    SeFePageModule,
    SeRegistrationUiFeatureOpenRegistrationListModule,
    SeRegistrationUiRegistrationCardModule,
    SeFeSpinnerModule,
    SeFeTranslationsModule.forChild('se-registration-ui/feature-completed-registration-list/assets'),
    TranslateModule,
  ],
  declarations: [
    CompletedRegistrationListComponent,
  ],
  exports: [
    CompletedRegistrationListComponent,
  ],
})
export class SeRegistrationUiFeatureCompletedRegistrationListModule {}
